import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import { useAdmin } from '../../contexts/AdminContext';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAdmin();
  const navigate = useNavigate();

  useEffect(() => { if (isAuthenticated) navigate('/admin'); }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    const result = await login(username, password);
    if (result.success) navigate('/admin');
    else { setError(result.error); setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5EFE6] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-[#FEFCF9] p-8 sm:p-10 border border-[#E8DCC8] relative">
          <div className="absolute -top-1.5 -left-1.5 w-14 h-14 border-t-2 border-l-2 border-[#C4A265]"></div>
          <div className="absolute -bottom-1.5 -right-1.5 w-14 h-14 border-b-2 border-r-2 border-[#C4A265]"></div>

          <div className="flex justify-center mb-8">
            <img src="https://customer-assets.emergentagent.com/job_behad-living/artifacts/rxtdz05y_Behat_Atelier.png" alt="Behat House Logo" className="h-20 w-auto object-contain" />
          </div>

          <h1 className="text-3xl font-serif text-[#3E2723] text-center mb-1">Admin Panel</h1>
          <p className="text-center text-[#7A6B5D] mb-8 text-sm">Behat House Atelier</p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 mb-6 text-sm">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-[#3E2723] mb-1.5 tracking-wider uppercase">Username</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#C4A265]" />
                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required
                  className="w-full pl-11 pr-4 py-3 border border-[#E8DCC8] bg-white focus:border-[#C4A265] focus:outline-none transition-colors"
                  placeholder="Enter username" data-testid="admin-username-input" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-[#3E2723] mb-1.5 tracking-wider uppercase">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#C4A265]" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                  className="w-full pl-11 pr-4 py-3 border border-[#E8DCC8] bg-white focus:border-[#C4A265] focus:outline-none transition-colors"
                  placeholder="Enter password" data-testid="admin-password-input" />
              </div>
            </div>

            <button type="submit" disabled={loading}
              className="w-full bg-[#3E2723] text-[#FEFCF9] py-3.5 font-semibold hover:bg-[#C4A265] transition-colors disabled:opacity-50 disabled:cursor-not-allowed tracking-wider uppercase text-sm"
              data-testid="admin-login-button">
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center text-xs text-[#A09486]">
            <p>Default credentials:</p>
            <p className="font-mono mt-1">admin | behathouse2025</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
